import { Endpoint } from '@business/api/endpoint';
import {
  ClientProposalDocumentResponse,
  PublicProposalDocumentResponse,
  TmAgreementId,
  TmAgreementResponse,
} from '@business/entities/tm/TmAgreementResponse';

export function fetchTmAgreements(tmId: string) {
  return Endpoint.get<TmAgreementResponse[]>(`@gc/tm-agreements`, { params: { tmId } });
}

/** Client portal: the documents generated for a work order's proposal. */
export function fetchClientProposalDocuments(tmId: string) {
  return Endpoint.get<ClientProposalDocumentResponse[]>(`@gc/tm-agreements/client-documents`, { params: { tmId } });
}

/** Public (no login): a proposal's terms document by the hash in its link. */
export function fetchPublicProposalDocument(hash: string) {
  return Endpoint.get<PublicProposalDocumentResponse>(`@gc/public/proposal-document/${hash}`);
}

export function fetchTmAgreement(id: TmAgreementId) {
  return Endpoint.get<TmAgreementResponse>(`@gc/tm-agreements/item/${id}`);
}

export function createTmAgreement(tmId: string, templateId: string) {
  return Endpoint.post<TmAgreementResponse>(`@gc/tm-agreements`, { data: { tmId, templateId } });
}

export function deleteTmAgreement(id: TmAgreementId) {
  return Endpoint.delete<void>(`@gc/tm-agreements/${id}`);
}
